import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotFoundLogo from '@/assets/images/404-icon.svg';
import { Button, Typography } from 'antd';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/dashboard');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh',
        textAlign: 'center',
        backgroundColor: '#f9f9f9',
        padding: '20px',
      }}
    >
      <img
        src={NotFoundLogo}
        alt="404"
        style={{ maxWidth: '500px', marginBottom: '20px', width: '100%' }}
      />
      <Typography.Title
        level={3}
        style={{ marginBottom: '10px', color: '#333' }}
      >
        404 - Page Not Found
      </Typography.Title>
      <Typography.Text style={{ marginBottom: '20px', color: '#666' }}>
        Sorry, the page you're looking for doesn't exist.
      </Typography.Text>
      <Button type="primary" onClick={handleRedirect} size="large">
        {' '}
        Go To Dashboard
      </Button>
    </div>
  );
};

export default NotFoundPage;
